import React, { Component } from 'react';
import styled from 'styled-components';
import { PRICES_EVENTS } from '../../../constants/CONTROLLERS_EVENT_TYPES';

class ClearButton extends Component<any, any> {
  constructor(props) {
    super(props);

    window.Widget.pricesController.addListener(PRICES_EVENTS.TOGGLE_PRICE, () => {
      const { size: selectedPricesSize } = window.Widget.pricesController.selectedPrices;
      this.setState({ selectedPricesSize });
    });

    this.state = {
      selectedPricesSize: 0,
    };
  }

  clearSelectedPrices() {
    window.Widget.pricesController.clearPrices();
  }

  render() {
    const { selectedPricesSize } = this.state;

    return (
      Boolean(selectedPricesSize) && (
        <StyledClearButton onClick={this.clearSelectedPrices}>
          <svg width="8" height="8" viewBox="0 0 8 8" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.52273 4L7.79545 6.27273C7.93182 6.40909 8 6.59091 8 6.77273C8 6.97727 7.93182 7.15909 7.79545 7.29545L7.29545 7.79545C7.13636 7.93182 6.95455 8 6.77273 8C6.56818 8 6.40909 7.93182 6.27273 7.79545L4 5.52273L1.72727 7.79545C1.59091 7.93182 1.40909 8 1.22727 8C1.02273 8 0.840909 7.93182 0.704545 7.79545L0.204545 7.29545C0.0681818 7.15909 0 6.97727 0 6.77273C0 6.59091 0.0681818 6.40909 0.204545 6.27273L2.47727 4L0.204545 1.72727C0.0681818 1.59091 0 1.43182 0 1.22727C0 1.04545 0.0681818 0.863636 0.204545 0.704545L0.704545 0.204545C0.840909 0.0681818 1.02273 0 1.22727 0C1.40909 0 1.59091 0.0681818 1.72727 0.204545L4 2.47727L6.27273 0.204545C6.40909 0.0681818 6.56818 0 6.77273 0C6.95455 0 7.13636 0.0681818 7.29545 0.204545L7.79545 0.704545C7.93182 0.863636 8 1.04545 8 1.22727C8 1.43182 7.93182 1.59091 7.79545 1.72727L5.52273 4Z" />
          </svg>
        </StyledClearButton>
      )
    );
  }
}

const StyledClearButton = styled.button`
  display: inline-block;
  margin: 0;
  padding: 0;
  border: 0;
  outline: none;
  opacity: 0.24;
  vertical-align: middle;
  margin-top: -1px;
  margin-left: 8px;
  background: transparent;
  transition: opacity 0.15s linear;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }

  @media screen and (max-width: 700px) {
    display: none;
  }
`;

export default ClearButton;
